/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IMediaGalleryThumbnailItemViewProps, IMediaGalleryThumbnailsViewProps } from '@msdyn365-commerce-modules/media-gallery';
import { IMediaGalleryViewProps } from './media-gallery';

const MediaGalleryView: React.FC<IMediaGalleryViewProps> = props => {
    const { CarouselProps, Thumbnails, MediaGallery, Modal, percentageOff } = props;
    const attributesData = props.data.productSpecificationData.result;
    // Sounrced from region
    let sourcedFromText = '';
    if (attributesData && attributesData.length > 0) {
        const filteredSpec = attributesData.filter(sp => {
            return sp.Name && sp?.Name === 'Sourced Region';
        });
        sourcedFromText = filteredSpec && filteredSpec.length > 0 && filteredSpec[0].TextValue ? filteredSpec[0].TextValue : '';
    }
    return (
        <Module {...MediaGallery}>
            {percentageOff > 0 && (
                <div className='pdp-offer'>
                    <div className='product-offer-label'>{percentageOff}% OFF</div>
                </div>
            )}
            {sourcedFromText && (
                <div className='pdp-product-label'>
                    <div className='flag'>
                        <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                            <g clip-path='url(#clip0_4341_4893)'>
                                <path
                                    d='M16.0015 7.99995C16.0015 8.93499 15.8411 9.83263 15.5464 10.6666H4.57031V5.33325H15.5464C15.8411 6.16735 16.0015 7.0649 16.0015 7.99986V7.99995Z'
                                    fill='#F7F7F7'
                                />
                                <path
                                    d='M15.5464 10.6666C15.3319 11.2735 15.0463 11.8467 14.6995 12.3763C13.2708 14.5585 10.8045 16 8.00155 16C6.77351 16 5.61012 15.7233 4.57031 15.2289V10.6667H15.5464V10.6666Z'
                                    fill='black'
                                />
                                <path
                                    d='M15.5464 5.33339H4.57031V0.771159C5.61012 0.276705 6.77351 0 8.00155 0C10.8045 0 13.2708 1.44154 14.6995 3.62371C15.0462 4.15328 15.3318 4.72654 15.5464 5.33339Z'
                                    fill='#006F2E'
                                />
                                <path
                                    d='M4.56876 0.771118V15.2287C3.74569 14.8373 3.00023 14.3097 2.36123 13.6747C1.96484 13.2808 1.6095 12.8457 1.30217 12.3762C0.478761 11.1188 0 9.61523 0 7.99996C0 6.38469 0.478762 4.88114 1.30209 3.62367C1.60942 3.15424 1.96484 2.71908 2.36123 2.32523C3.00023 1.6903 3.74569 1.16251 4.56876 0.771203V0.771118Z'
                                    fill='#F70000'
                                />
                            </g>
                            <defs>
                                <clipPath id='clip0_4341_4893'>
                                    <rect width='16' height='16' fill='white' />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                    {sourcedFromText}
                </div>
            )}
            <Node {...CarouselProps} />
            {Modal}
            {_renderThumbnails(Thumbnails)}
        </Module>
    );
};

const _renderThumbnails = (thumbnails: IMediaGalleryThumbnailsViewProps): JSX.Element => {
    const { ThumbnailsContainerProps, SingleSlideCarouselComponentProps, items } = thumbnails;

    return (
        <Node {...ThumbnailsContainerProps}>
            <Node {...SingleSlideCarouselComponentProps}>{items && items.map(_renderThumbnailItem)}</Node>
        </Node>
    );
};

const _renderThumbnailItem = (thumbnail: IMediaGalleryThumbnailItemViewProps): JSX.Element => {
    const { ThumbnailItemContainerProps, Picture } = thumbnail;

    return <Node {...ThumbnailItemContainerProps}>{Picture}</Node>;
};

export default MediaGalleryView;
